<template>

  <EditSubjectEditor></EditSubjectEditor>
</template>


<style type="text/css">

   

</style>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import EditSubjectEditor from "@/components/EditSubjectEditor.vue";





export default {
  name: "TestSubject",
  components: {
    EditSubjectEditor
    
  }

  
};
</script>
